import {isMacOS} from '@github-ui/get-os'
import {
  getImageSizeFromFile as imageUtilsGetImageSizeFromFile,
  markdownComment as imageUtilsMarkdownComment,
  markdownImageTag as imageUtilsMarkdownImageTag,
  markdownLink as imageUtilsMarkdownLink,
} from '@github-ui/image-utils'

import type {ImageDimensions} from './types'

export const getSelectedLineRange = (textarea: HTMLTextAreaElement): [number, number] => {
  // Subtract one from the caret position so the newline found is not the one _at_ the caret position
  // then add one because we don't want to include the found newline. Also changes -1 (not found) result to 0
  const start = textarea.value.lastIndexOf('\n', textarea.selectionStart - 1) + 1

  // activeLineEnd will be the index of the next newline inclusive, which works because slice is last-index exclusive
  let end = textarea.value.indexOf('\n', textarea.selectionEnd)
  if (end === -1) end = textarea.value.length

  return [start, end]
}

export const markdownComment = (text: string) => imageUtilsMarkdownComment(text)

export const markdownLink = (text: string, url: string) => imageUtilsMarkdownLink(text, url)

export const isModifierKey = (event: KeyboardEvent | React.KeyboardEvent<unknown>) =>
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
  isMacOS() ? event.metaKey : event.ctrlKey

export const getImageSizeFromFile = async (file: File) => {
  const result = await imageUtilsGetImageSizeFromFile(file)
  if (!result) return null

  // Adapt from pixelsPerInch to ppi for backward compatibility
  return {
    width: result.width,
    height: result.height,
    ppi: result.pixelsPerInch,
  }
}

export const markdownImageTag = (dimensions: ImageDimensions, src: string, alt: string = 'Image') => {
  // Adapt from ppi to pixelsPerInch for the image-utils function
  return imageUtilsMarkdownImageTag(
    {
      width: dimensions.width,
      height: dimensions.height,
      pixelsPerInch: dimensions.ppi,
    },
    src,
    alt,
  )
}
